export default __webpack_public_path__ + "static/media/cebg.11eecd3a.png";